module.exports = __webpack_public_path__ + "static/media/management-portals.408d6d3f.svg";